// Packages
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.css";
import { connect } from "react-redux";

// Views
import SuperAdminDashboard from "../superAdmin/superAdminDashboard";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
// Services
import userService from "../../services/user.service";
// Styles
import "./superAdmin.css";
// Assets
import menuthree from "../../assets/images/menuthree.png";
import { BsXLg } from "react-icons/bs";
import Moment from "moment";
import { FaTrash } from "react-icons/fa";
import ErrorMessage from "../../Common/ErrorMessage";
import { CircularProgress, Paper } from "@material-ui/core";
import CustomSearch from "../../Common/CustomSearch";
import { DataGrid } from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/Delete";
import ConfirmationDialog from "../schoolAdminPortal/Popups/ConfirmationDialog";
import SuccessDialog from "../schoolAdminPortal/Popups/SuccessDialog";
import { formatPhoneNumber } from "../../utils";
import { getFromLocalStorage } from "../../utils/webStorage";
import PageNotFoundPage from "../../Common/PageNotFoundPage";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
// Material Ui
import ListMenu from "../../Common/ListMenu";
import { openConfirmationPopup } from "../../Redux/Actions/PopupActions";

class WebsiteDetails extends Component {
  constructor(props) {
    super();
    this.myref = React.createRef();
    this.state = {
      showfive: false,
      allSchoolList: [],
      allWebEnquiries: [],
      showMessage: "",
      headingContactUS: "",
      subHeadingContactUs: "",
      ContactUsId: null,
      open: false,
      modalId: "",

      columns: [],
      total: null,
      openEmail: false,
      modalEmail: "",
      submitting: false,
      openname: false,
      currentNotification: null,
      currentEmail: null,
      redirect: false,
      disabled: false,
      search: false,

      pageState: {
        isLoading: false,
        data: [],
        total: 0,
        page: 0,
        pageSize: 10,
      },
      redirectToRow: false,
      searchQuery: "",
      searchedRecord: false,
      deletePopup: false,
      msg: "",
      currentAthleteId: "",
      successPopup: false,
      recordNotFound: false,
      currentRowId: "",
      confirmPopUp: false,
      loginRole: getFromLocalStorage("loginRole"),
    };
  }

  columns = [
    { title: "id", field: "id", hidden: true },
    {
      title: "ENQUIRY DATE",
      field: "createdAt",
      type: "date",
      dateSetting: { locale: "en-US" },
      render: (row) => (
        <div
          className="link-blue cp text-dark"
          key="row.id"
          onClick={() =>
            this.openDialogName(
              row.name,
              row.phoneNo,
              row.email,
              row.subject,
              row.message
            )
          }
        >
          {Moment(row.createdAt).format("MM/DD/YYYY")}
        </div>
      ),
    },

    {
      title: "NAME",
      field: "name",
      render: (row) => (
        <div
          className="link-blue cp text-width-auto"
          key="row.id"
          onClick={() =>
            this.openDialogName(
              row.name,
              row.phoneNo,
              row.email,
              row.subject,
              row.message
            )
          }
        >
          {row.name}
        </div>
      ),
    },

    {
      title: "EMAIL",
      field: "email",
      render: (row) => (
        <div
          className="text-width-auto"
          onClick={() =>
            this.openDialogName(
              row.name,
              row.phoneNo,
              row.email,
              row.subject,
              row.message
            )
          }
        >
          <label className="cp">{row.email}</label>
        </div>
      ),
    },
    {
      title: "PHONE NO",
      field: "phoneNo",
      render: (row) => (
        <div
          className="link-blue text-dark text-width-auto"
          key="row.id"
          onClick={() =>
            this.openDialogName(
              row.name,
              row.phoneNo,
              row.email,
              row.subject,
              row.message
            )
          }
        >
          <label className="cp">{row.phoneNo}</label>
        </div>
      ),
    },

    {
      render: (rowData) => (
        <div class="dropdown">
          <span className="cp three-dot ">
            <img className="cp" src={menuthree} alt="menu"></img>{" "}
          </span>
          <div class="dropdown-content manage-dropdown-content">
            <div
              className="manage-section-dropdown-item cp"
              onClick={() => this.openDialog(rowData.id)}
            >
              <FaTrash className="manage-section-iconss delete-icon" />
              <div className="manage-section-dropdown-item-link">
                <p className="manage-small-popup-menuu1-p">Delete</p>
              </div>
            </div>
          </div>
        </div>
      ),
    },
  ];

  openDialogName(name, phone, email, subject, message) {
    const { openname } = this.state;

    this.setState({
      personName: name,
      personPhone: phone,
      personEmail: email,
      personSubject: subject,
      personMessage: message,
      openname: !openname,
    });
  }
  closeDialogName() {
    const { openname } = this.state;
    this.setState({ openname: !openname });
  }

  componentDidMount() {
    const acticve = document.getElementById("Website");
    if (acticve) {
      acticve.classList.add("active");
    }
    this.setState({ submitting: true });
    this.getWebsiteEnquiriesData();
    this.getAllWebsiteEnquiriesByPage(
      this.state.pageState.page,
      this.state.pageState.pageSize
    );

    this.getContactUs();
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.getDetailsbyEmail();
    }
  }

  getWebsiteEnquiriesData() {
    this.setState({
      submitting: true,
    });
    userService
      .getAllWebsiteEnquiries()
      .then((response) => {
        if (response.data.status == true) {
          var allWebEnquiries = response.data.data.contactUsDetailsResponses;
          let search = true;
          if (allWebEnquiries.length === 0) {
            search = false;
          }
          this.setState({ allWebEnquiries, search, submitting: false });
          allWebEnquiries && this.getDetailsbyEmail();
        }
      })
      .catch((error) => {
        this.setState({
          submitting: false,
        });
        console.error("There was an error!", error);
      });
  }

  getAllWebsiteEnquiriesByPage = (page, size) => {
    const { schoolId, recordNotFound } = this.state;
    this.setState({ pageState: { ...this.state.pageState, isLoading: true } });
    userService
      .getAllWebsiteEnquiriesByPage(page, size)
      .then((res) => {
        this.setState({
          pageState: {
            ...this.state.pageState,
            data: res.data.data.contactUsDetailsResponses,
            isLoading: false,
            total: res.data.data.total,
            page: page,
          },
          submitting: false,
        });
        if (recordNotFound) {
          this.setRecordNotFound();
        }
      })
      .catch((err) => {
        console.error(err);
        this.setState({ submitting: false });
      });
  };

  getDetailsbyEmail() {
    const queryParams = window.location.search;
    const id = queryParams.split("=")[1];
    if (id) {
      const { allWebEnquiries } = this.state;
      const matchedData = allWebEnquiries.find((data) => data?.email === id);
      this.openDialogName(
        matchedData?.name,
        matchedData?.email,
        matchedData?.email,
        matchedData?.subject,
        matchedData?.message,
        () => {
          this.setState({ redirect: true });
        }
      );
    }
  }

  updateContactUs({ contactHeading, contactSubHeading }) {
    this.setState({ disabled: true });
    const { ContactUsId } = this.state;
    userService
      .updateWebsiteContactUs(contactHeading, contactSubHeading, ContactUsId)
      .then((res) => {
        let showMessage = res.data.data;
        this.setState({
          msg: "Data updated successfully",
          successPopup: true,
          showMessage,
          disabled: false,
        });
      });
  }

  contactUsCall() {
    const { headingContactUS, subHeadingContactUs } = this.state;
    userService
      .addWebsiteContactUs(headingContactUS, subHeadingContactUs)
      .then((res) => {
        var showMessage = res.data.data;
        this.setState({ showMessage });
      });
  }

  getContactUs() {
    userService.getAllWebsiteContactUs().then((res) => {
      var headingContactUS =
        res.data.data.websiteContactUsDetailsResponses[0].heading;
      var subHeadingContactUs =
        res.data.data.websiteContactUsDetailsResponses[0].subHeading;
      var ContactUsId = res.data.data.websiteContactUsDetailsResponses[0].id;
      this.setState({ headingContactUS, subHeadingContactUs, ContactUsId });
    });
  }

  openDialog = (row) => {
    const { setConfirmationPopup } = this.props;
    setConfirmationPopup({
      confirmationPopup: {
        open: true,
        message: "Are you sure you want to remove the record?",
        btnColor: "red",
        btnText: "Yes",
        type: "Delete contact us inquiry",
        id: row.id,
        apiToCall: () => this.deleteEnquiriesById(row.id),
      },
    });
  };

  deleteEnquiriesById = (id) => {
    const { modalId, searchedRecord, searchQuery, pageState } = this.state;
    userService
      .deleteContactUsEnquiriesById(id)
      .then((response) => {
        const newPageNumber =
          pageState.data.length == 1 && pageState.page > 0
            ? pageState.page - 1
            : pageState.page;
        if (searchedRecord) {
          this.searchWebsiteEnquiries(searchQuery, newPageNumber, 10);
        } else {
          this.getAllWebsiteEnquiriesByPage(newPageNumber, 10);
        }
        this.setState({
          confirmPopUp: false,
          successPopup: true,
          msg: "Record removed",
        });
      })
      .catch((error) => {
        this.openDialogWrong();
      });
  };

  openDialogRemoved() {
    const { openRemove } = this.state;
    this.setState({ openRemove: !openRemove });
  }

  openDialogWrong() {
    const { openWrong } = this.state;
    this.setState({ openWrong: !openWrong });
  }
  closeDialogWrong() {
    const { openWrong } = this.state;
    this.setState({ openWrong: !openWrong });
  }

  ConfirmcloseDialog = () => {
    const { open } = this.state;
    this.setState({ open: !open });
    this.deleteEnquiriesById();
  };

  closeDialog = () => {
    const { open } = this.state;
    this.setState({ open: !open });
  };

  setSearchedRecord = (value) => {
    this.setState({ searchedRecord: value });
  };

  setSearchQuery = (value) => {
    this.setState({ searchQuery: value });
  };

  setRecordNotFound = () => {
    this.setState({ recordNotFound: false });
  };

  toggleConfirmDialog = () => {
    const { confirmPopUp } = this.state;
    this.setState({ confirmPopUp: !confirmPopUp });
  };

  toggleSuccessDialog = () => {
    const { successPopup } = this.state;
    this.setState({ successPopup: !successPopup });
  };

  searchWebsiteEnquiries = (query, page, size) => {
    const { schoolId, searchedRecord } = this.state;
    this.setState({
      pageState: { ...this.state.pageState, isLoading: true },
      searchQuery: query,
    });
    if (!searchedRecord) {
      this.setState({ searchedRecord: true });
    }
    userService
      .searchWebsiteEnquiries(query, page, size)
      .then((res) => {
        this.setState({
          pageState: {
            ...this.state.pageState,
            data: res.data.data.contactUsDetailsResponses,
            isLoading: false,
            total: res.data.data.total,
            page: page,
          },
          recordNotFound:
            res.data.data.contactUsDetailsResponses.length == 0 ? true : false,
        });
      })
      .catch((err) => {
        console.error(err);
        this.setState({
          pageState: {
            ...this.state.pageState,
            data: [],
            isLoading: false,
            total: 0,
            page: page,
          },
          recordNotFound: true,
        });
      });
  };

  handleChange = (event, newValue, param) => {
    userService
      .updateContactUsResolvedStatus(
        param?.id,
        newValue === "yes" ? true : false
      )
      .then((res) => {
        this.state.pageState.data.map((data) => {
          if (data.id === param.id) {
            data.resolved = newValue === "yes" ? true : false;
            this.setState({ pageState: { ...this.state.pageState } });
          }
        });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  render() {
    const {
      personName,
      personPhone,
      personEmail,
      personSubject,
      personMessage,
      redirect,
      openname,
      submitting,
      pageState,
      searchQuery,
      recordNotFound,
      searchedRecord,
      redirectToRow,
      confirmPopUp,
      msg,
      successPopup,
      loginRole,
    } = this.state;

    const tableColumns = [
      {
        field: "enquiryDate",
        headerName: "Enquiry Date",
        headerAlign: "center",
        align: "center",
        headerClassName: "table-header bold",
        flex: 1,
        minWidth: 150,
      },
      {
        field: "name",
        headerName: "Name",
        headerAlign: "center",
        headerClassName: "table-header bold",
        flex: 1,
        minWidth: 200,
        renderCell: (params) => {
          return (
            <div className="d-flex-align-cent height-70 w-100">
              <p className="link-blue text-width-auto mg-left-10">
                {params.row.name}
              </p>
            </div>
          );
        },
      },
      {
        field: "email",
        headerName: "Email",
        headerAlign: "center",
        headerClassName: "table-header bold",
        flex: 1,
        minWidth: 200,
        renderCell: (params) => {
          return (
            <div className="d-flex-align-cent height-70 w-100">
              <p className="text-width-auto mg-left-10">{params.row.email}</p>
            </div>
          );
        },
      },
      {
        field: "phoneNo",
        headerName: "Phone Number",
        flex: 1,
        minWidth: 200,
        headerClassName: "table-header bold",
        headerAlign: "center",
        align: "center",
        renderCell: (params) => <p>{formatPhoneNumber(params.row.phoneNo)}</p>,
      },
      {
        field: "resolved",
        headerName: "Resolved",
        flex: 1,
        minWidth: 100,
        headerClassName: "table-header bold",
        headerAlign: "center",
        align: "center",
        renderCell: (params) => (
          <ToggleButtonGroup
            color="primary"
            exclusive
            aria-label="Platform"
            value={params.row?.resolved ? "yes" : "no"}
            onChange={(event, newValue) =>
              this.handleChange(event, newValue, params.row)
            }
          >
            <ToggleButton value="yes">Yes</ToggleButton>
            <ToggleButton value="no">No</ToggleButton>
          </ToggleButtonGroup>
        ),
      },
      {
        headerClassName: "table-header bold",
        headerName: "Action",
        cellClassName: "mng-z-index2",
        headerAlign: "center",
        align: "center",
        sortable: false,
        height: 100,
        renderCell: (params) => (
          <ListMenu
            menuContent={menuItemContent(params.row)}
            rowData={params.row}
          />
        ),
      },
    ];

    const menuItemContent = (data) => {
      const arr = [
        {
          id: "1",
          name: "Delete",
          icon: <DeleteIcon className="manage-section-iconss delete-icon" />,
          ApiCall: this.openDialog,
        },
      ];
      return arr;
    };

    return (
      <>
        {loginRole === "SUPER ADMIN" ? (
          <div id="superAdmin-table" className="">
            <SuperAdminDashboard />
            <div className="content-layout pt-20">
              <div className="mng-header stickyy">
                <h4 className="fs-24 bold mob-hd">CONTACT US</h4>
              </div>
              <div className="row w-100">
                <div className="col-12 col-md-12 col-lg-12 w-100">
                  {/* Website Enquiries Section */}

                  <div className="panel-content-table conclass-website-table plr">
                    {!submitting &&
                      pageState.data.length === 0 &&
                      !recordNotFound && <ErrorMessage />}

                    {!submitting &&
                      (pageState.data.length > 0 || recordNotFound) && (
                        <Paper className="pad-top-20">
                          <CustomSearch
                            searchQuery={searchQuery}
                            setSearchQuery={this.setSearchQuery}
                            setSearchedRecord={this.setSearchedRecord}
                            searchedRecord={searchedRecord}
                            getDataByPage={this.getAllWebsiteEnquiriesByPage}
                            pageState={pageState}
                            searchData={this.searchWebsiteEnquiries}
                            setRecordNotFound={this.setRecordNotFound}
                          />
                          <DataGrid
                            rows={pageState.data}
                            rowCount={pageState.total}
                            loading={pageState.isLoading}
                            pagination
                            page={pageState.page}
                            columns={tableColumns}
                            pageSize={pageState.pageSize}
                            rowsPerPageOptions={[10]}
                            paginationMode="server"
                            onPageChange={(newPage) => {
                              if (searchQuery == "") {
                                this.getAllWebsiteEnquiriesByPage(newPage, 10);
                              } else {
                                this.getAllWebsiteEnquiriesByPage(
                                  searchQuery,
                                  newPage,
                                  10
                                );
                              }
                              this.setState({
                                ...pageState,
                                page: newPage,
                              });
                            }}
                            onPageSizeChange={(newPageSize) =>
                              this.setState({
                                ...pageState,
                                pageSize: newPageSize,
                              })
                            }
                            sx={{
                              color: "black",
                              fontFamily: "Rajdhani-SemiBold",
                              fontSize: "18px",
                              backgroundColor: "white",
                              borderBottomLeftRadius: "12px",
                              borderBottomRightRadius: "12px",
                            }}
                            onCellClick={(param) => {
                              if (param.field !== "resolved")
                                this.openDialogName(
                                  param.row.name,
                                  param.row.phoneNo,
                                  param.row.email,
                                  param.row.subject,
                                  param.row.message
                                );
                            }}
                            autoHeight
                            disableColumnMenu
                            getRowHeight={() => "auto"}
                            disableSelectionOnClick
                          />
                        </Paper>
                      )}
                  </div>
                </div>
              </div>
            </div>

            {/* Dialogs */}
            <Dialog
              id="dialogWebsiteContact"
              className="dialog-style"
              open={openname}
              onClose={this.closeDialogName.bind(this)}
            >
              <DialogTitle>
                <div className="row dialog-border">
                  <div className="col-11">
                    <p className="coach-list fs-22 black medium txt-center">
                      Contact Us
                    </p>
                  </div>
                  <div className="col-1 text-right ml-auto ">
                    <BsXLg
                      onClick={this.closeDialogName.bind(this)}
                      className="crossview cp"
                    />
                  </div>
                </div>
              </DialogTitle>

              <DialogContent>
                <div className="clear10"></div>
                <div className="row">
                  <div className="col-lg-6">
                    <label className="fs-18 semibold">Name</label>
                    <div className="fs-18 semibold txtgrey">{personName}</div>
                  </div>
                  <div className="col-lg-6">
                    <label className="fs-18 semibold">EMAIL ADDRESS</label>
                    <div className="link-blue fs-16 semibold">
                      {personEmail}
                    </div>
                  </div>
                </div>
                <div className="clear10"></div>
                <div className="row">
                  <div className="col-lg-6">
                    <label className="fs-18 semibold">PHONE NO</label>
                    <div className="fs-18 semibold txtgrey">{personPhone}</div>
                  </div>
                  <div className="col-lg-6">
                    <label className="fs-18 semibold">Message</label>
                    <div className="fs-18 semibold txtgrey">
                      {personMessage}
                    </div>
                  </div>
                </div>
                <div className="clear10"></div>
              </DialogContent>
            </Dialog>

            <ConfirmationDialog
              confirmPopUp={confirmPopUp}
              toggleConfirmDialog={this.toggleConfirmDialog}
              btnColor="red"
              btnText="Remove"
              ApiToCall={this.deleteEnquiriesById}
              msg={msg}
            />

            <SuccessDialog
              successPopUp={successPopup}
              toggleSuccessDialog={this.toggleSuccessDialog}
              msg={msg}
            />

            {submitting && (
              <CircularProgress className="circle-mark" color="secondary" />
            )}
          </div>
        ) : (
          <PageNotFoundPage />
        )}
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setConfirmationPopup: (obj) => openConfirmationPopup(dispatch, obj),
  };
};

export default withRouter(connect(null, mapDispatchToProps)(WebsiteDetails));
